import { reactive } from '../../js/reactive';
import { data } from './data';
import { ajax } from './ajax';
import { lazyImageVNode } from '../../js/helpers/lazyImageVNode';
import { splitProductTitle } from '../../js/helpers/splitProductTitle';
import { duplicates } from './duplicates';
import { a11yTextVNode } from '../../js/a11y';
import { isNotNullOrUndef } from '../../js/helpers/isNotNullOrUndef';
const vNode = window.vNode;
let oldItemsBlock = null;
const createImage = (item, isDuplicate) => {
    const image3D = item.image3D;
    const { _userImageLink, _userImageMask, _userImageSize, _userImagePosition } = item.properties;
    const imageUrl = _userImageMask ?? image3D ?? item.image;
    const imageVNode = vNode.create('a', {
        class: 'ss__cart_item_image',
        href: item.url,
        'aria-hidden': 'true'
    }, [
        vNode.create('div', { class: 'image-wrapper' }, [
            lazyImageVNode({
                url: imageUrl,
                alt: item.product_title,
                maxWidth: 700,
                ...(isNotNullOrUndef(_userImageLink) &&
                    isNotNullOrUndef(_userImagePosition) &&
                    isNotNullOrUndef(_userImageSize) &&
                    {
                        styles: `background:url(${_userImageLink.replace('final_image', 'preview_image')}) ${_userImagePosition} / ${_userImageSize} no-repeat;`
                    })
            })
        ])
    ]);
    if (isDuplicate) {
        imageVNode.children[0].children.push(vNode.create('s-svg', {
            'data-icon': '#icon--error',
            style: 'aspect-ratio: 28 / 26'
        }));
    }
    return imageVNode;
};
const createTitle = (item) => {
    return vNode.create('a', {
        class: 'ss__cart_item_title',
        href: item.url
    }, (function () {
        const { title, subtitle } = splitProductTitle(item.product_title);
        return [
            vNode.create('b', {}, [title]),
            vNode.create('b', {}, [subtitle]),
            a11yTextVNode('. Selected options: ' + item.options_with_values.map((option) => {
                return option.name + ' - ' + option.value;
            }).join(', ') + '.'),
            a11yTextVNode(`Price: $${item.old_line_price}. Price after discount: $${item.final_line_price}`)
        ];
    }()));
};
const createOptions = (item) => {
    return vNode.create('a', {
        class: 'ss__cart_item_options',
        href: item.url,
        'aria-hidden': 'true'
    }, (function () {
        const arr = [];
        item.options_with_values.forEach((option) => {
            if (option.name.toLowerCase() === 'color')
                return;
            arr.push(vNode.create('span', { class: 'ss__cart_item_options_name' }, [option.name + ':']));
            arr.push(vNode.create('span', { class: 'ss__cart_item_options_value' }, [(option.value.includes('-') ? option.value.split('-')[1].trim() : option.value)]));
        });
        if (isNotNullOrUndef(item.properties)) {
            Object.keys(item.properties).sort().forEach(key => {
                if (key.startsWith('_'))
                    return;
                arr.push(vNode.create('span', { class: 'ss__cart_item_options_name' }, [`${key}:`]));
                arr.push(vNode.create('span', { class: 'ss__cart_item_options_value' }, [item.properties[key]]));
            });
        }
        return arr;
    }()));
};
const createQuantity = (item, lineNumber, isDuplicate) => {
    return vNode.create('div', { class: `ss__cart_item_quantity${isDuplicate ? ' ss__cart_item_quantity--red' : ''}` }, [
        vNode.create('span', { class: 'ss__cart_item_quantity_title' }, [
            'QUANTITY',
            a11yTextVNode(`: ${item.quantity}`)
        ]),
        vNode.create('div', { class: 'ss__cart_item_quantity_buttons' }, [
            ...(item.sku === 'Custom_TILE'
                ? []
                : [vNode.create('button', {
                        class: 'btn:cleared',
                        'aria-label': 'Decrease',
                        events: {
                            click: event => {
                                const target = event.currentTarget;
                                addLoader(target.closest('li'));
                                ajax.updateQuantity(Math.max(item.quantity - 1, 0), lineNumber);
                            }
                        }
                    }, [
                        vNode.create('s-svg', { 'data-icon': '#icon--cart-minus', style: 'aspect-ratio: 28 / 28;' })
                    ])]),
            vNode.create('span', {
                class: 'ss__cart_item_quantity_count',
                'aria-hidden': 'true'
            }, [item.quantity]),
            ...(item.sku === 'Custom_TILE'
                ? []
                : [vNode.create('button', {
                        class: 'btn:cleared',
                        'aria-label': 'Increase',
                        events: {
                            click: event => {
                                const target = event.currentTarget;
                                addLoader(target.closest('li'));
                                ajax.updateQuantity(item.quantity + 1, lineNumber);
                            }
                        }
                    }, [
                        vNode.create('s-svg', { 'data-icon': '#icon--cart-plus', style: 'aspect-ratio: 28 / 28;' })
                    ])])
        ])
    ]);
};
const addLoader = (parent) => {
    const quantityElem = parent.querySelector('.ss__cart_item_quantity_count');
    const spinnerVNode = vNode.create('span', { class: 'ss__cart_item_quantity_count' }, [
        vNode.create('i', { class: 'icon--loader' })
    ]);
    vNode.patch(quantityElem._vNode, spinnerVNode);
    quantityElem._vNode = spinnerVNode;
};
const createEditButtons = (item, lineNumber) => {
    return vNode.create('div', {
        class: 'ss__cart_item_edit-buttons'
    }, [
        vNode.create('a', {
            href: item.url,
            'aria-label': 'Edit',
            'aria-describedby': 'adb_open adb_word-product'
        }, [
            vNode.create('s-svg', { 'data-icon': '#icon--edit', style: 'aspect-ratio: 14 / 14;' })
        ]),
        vNode.create('button', {
            class: 'btn:cleared',
            'aria-label': 'Remove',
            'aria-describedby': 'adb_remove',
            events: {
                click: event => {
                    const target = event.currentTarget;
                    addLoader(target.closest('li'));
                    ajax.updateQuantity(0, lineNumber);
                }
            }
        }, [
            vNode.create('s-svg', { 'data-icon': '#icon--close-x', style: 'aspect-ratio: 17.4 / 17.4;' })
        ])
    ]);
};
const createPrices = (item) => {
    return vNode.create('div', { class: 'ss__cart_item_prices', 'aria-hidden': 'true' }, [
        vNode.create('s', {
            class: 'ss__cart_item_prices_old'
        }, [`$${item.old_line_price}`]),
        vNode.create('span', {
            class: 'ss__cart_item_prices_new'
        }, [`$${(item.final_line_price).toFixed(2)}`]),
        ...(item.line_level_discount_allocations.length < 1
            ? []
            : [
                vNode.create('span', { class: 'd:block w:min-content ml:auto text:uppercase ss__cart_item_prices_discount' }, [item.line_level_discount_allocations[0].discount_application.title])
            ])
    ]);
};
const createItemVNode = (item, index, isDuplicate) => {
    return vNode.create('li', { key: item.key, class: 'ss__cart_item' }, [
        createImage(item, isDuplicate),
        createTitle(item),
        createOptions(item),
        createQuantity(item, index + 1, isDuplicate),
        createEditButtons(item, index + 1),
        createPrices(item)
    ]);
};
export const renderItems = (container) => {
    reactive.watch(() => {
        const duplicatesList = duplicates.getLineNumbers();
        const newItemsBlock = vNode.create('div', { class: 'ss__cart_items-wrapper scrbar:none ov:x:h ov:y:a' }, (function () {
            const retArr = [];
            retArr.push(vNode.create('div', {
                class: 'ss__cart_duplicate-message',
                hidden: duplicatesList.length === 0
            }, [
                vNode.create('s-svg', { 'data-icon': '#icon--error-fill', style: 'aspect-ratio: 28 / 26' }),
                vNode.create('p', {}, [
                    vNode.create('b', {}, ['NOTE: ']),
                    'There are duplicate Artworks in your cart'
                ])
            ]));
            if (data.items.length === 0) {
                retArr.push(vNode.create('p', { class: 'ss__cart_empty-message' }, (function () {
                    if (data.itemCount > 0) {
                        return [
                            vNode.create('i', { class: 'icon--loader' })
                        ];
                    }
                    else {
                        return [
                            vNode.create('img', {
                                src: 'https://cdn.shopify.com/s/files/1/1568/8443/files/empty-cart.svg?v=1611820008',
                                alt: ''
                            }),
                            'Your cart is currently empty.'
                        ];
                    }
                }())));
            }
            else {
                retArr.push(vNode.create('ul', { class: 'ss__cart_items' }, data.items.map((item, index) => {
                    const isDuplicate = duplicatesList.includes(index);
                    return createItemVNode(item, index, isDuplicate);
                })));
            }
            return retArr;
        }()));
        vNode.patch(oldItemsBlock, newItemsBlock, container);
        oldItemsBlock = newItemsBlock;
    });
};
